/**
 * Created by anthony on 11/20/14.
 */
stateProviders.push({
    name: 'schoolside.application',
    url: '/applications/:applicationID',
    templateUrl: 'fast/submodules/schoolside/applications/partials/applications.html?v=' + versionNo,
    controller: "ApplicationsController",
    resolve :
    {
        bins: function(BinFactory)
        {
            if (BinFactory.getLastUpdated() == 0)
                return BinFactory.retrieveData();
        },
        schoolSubcategories: function(SchoolSubcategoriesModelService, authServiceFactory)
        {
            return SchoolSubcategoriesModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        },
        awardLetters: function(AwardLetterTemplatesModelService, authServiceFactory)
        {
            AwardLetterTemplatesModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        questions: function(AskSchoolSpecificQuestionsModelService, authServiceFactory)
        {
            return AskSchoolSpecificQuestionsModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }

});

stateProviders.push({
    name: 'schoolside.applications',
    url: '/applications',
    templateUrl: 'fast/submodules/schoolside/applications/partials/applications.html?v=' + versionNo,
    controller: "ApplicationsController",
    resolve :
    {
        bins: function(BinFactory)
        {
                return BinFactory.retrieveData();
            
        },
        schoolSubcategories: function(SchoolSubcategoriesModelService, authServiceFactory)
        {
            return SchoolSubcategoriesModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        permissions: function(PermissionModelService, authServiceFactory)
        {
            PermissionModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        grades: function(GradeSetupModelService, authServiceFactory)
        {
            GradeSetupModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        committeeUsers: function(CommitteeUserModelService, authServiceFactory)
        {
            CommitteeUserModelService.get(authServiceFactory.getAuth().schoolID);
        },
        fees: function(FeeAgreementModelService, authServiceFactory)
        {
            return FeeAgreementModelService.get(authServiceFactory.getAuth().schoolID); 
        }
    }

});